import { render, staticRenderFns } from "./VueMenuItem.vue?vue&type=template&id=3623e0f9&"
import script from "./VueMenuItem.vue?vue&type=script&lang=js&"
export * from "./VueMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports